module.exports = __webpack_public_path__ + "static/img/2.dc58bd6e.jpg";